module.exports = __webpack_public_path__ + "static/basak-pinduk-81fbe494ebf30bcea6997b7bf53402de.webp";